export { default as LoyaltyDoubleButtonWidget } from './loyalty-double-button-widget';
